import { XUIModalBody, XUIModalHeader } from '@xero/xui/react/modal';
import customConnection from './customConnection';

export default {
    CUSTOM: customConnection,
    BUTTONS: {
        ADD_NEW: 'Add new',
        APP_SIGNUP: 'Not a integrationName user? Sign up',
        BACK: 'Back',
        CANCEL: 'Cancel',
        CONNECT: 'Finish & connect',
        CONNECT_APP: 'Connect app',
        CONTINUE: 'Continue',
        DISCONNECT: 'Disconnect app',
        START_FREE_TRIAL: 'Start free trial',
        NEXT: 'Next',
        START_SET_UP: 'Start set up',
        SAVE: 'Save',
        SAVE_LIST: 'Save list',
        SETTINGS: 'Manage settings',
        MANAGE_SUBSCRIPTION: 'Manage subscription',
        UPDATE_APP: 'Update app',
        SETUP_NOW: 'Setup now',
        COMPLETE_SETUP: 'Complete setup',
        SKIP_INTRODUCTION: 'Skip introduction',
        SYNC: 'Sync',
        UPDATE: 'Update',
        UPGRADE_SUBSCRIPTION: 'Upgrade subscription',
        XERO_PRICING: 'xero.com/pricing',
        CANCEL_PENDING_CANCELLATION: 'Cancel pending cancellation',
    },
    DATE_OPTIONS: {
        SELECT_DATE: 'Select date',
    },
    ACTIVITY_TABLE: {
        A_BILL_CREATED: '1 bill created',
        QTY_BILLS_CREATED: '{qty} bills created',
        A_CONTACT: '1 contact',
        QTY_CONTACTS: '{qty} contacts',
        AN_INVOICE_CREATED: '1 invoice created',
        QTY_INVOICES_CREATED: '{qty} invoices created',
        AN_INVOICE_PAYMENT: '1 invoice payment',
        QTY_INVOICE_PAYMENTS: '{qty} invoice payments',
        AN_ORDER: '1 order',
        QTY_ORDERS: '{qty} orders',
        A_TRANSFER: '1 transfer',
        QTY_TRANSFERS: '{qty} transfers',
        BY_USERNAME: 'by {username}',
        BANK_ACCOUNT: 'Bank account',
        BANK_ACCOUNT_LINKED_DELETED: 'The bank account linked to the integration has been deleted',
        BANK_ACCOUNTS_VALID: 'Bank accounts valid',
        BANK_TO_CLEARING: 'made from bank account to clearing account',
        CHART_OF_ACCOUNT: 'Chart of account',
        CHART_OF_ACCOUNTS: 'Chart of accounts',
        CLEARING_ACCOUNT: 'Clearing account',
        CLEARING_ACCOUNT_LINKED_DELETED: 'The clearing account linked to the integration has been deleted',
        CLEARING_ACCOUNTS_VALID: 'Clearing accounts valid',
        CLEARING_TO_BANK: 'made from clearing account to bank account',
        COA_LINKED_DELETED: 'One or more chart of accounts that are assigned to expenses or revenue have been deleted',
        COAS_VALID: 'Chart of accounts valid',
        CONNECTION_CREATED: 'Connection created',
        CONNECTION_ERROR_WITH_INSTALLATION: 'Could not establish connection with {installation}',
        CONTACT_CREATED: 'Contact created',
        QTY_CONTACTS_CREATED: '{qty} contacts created',
        CONTACT_VALID: 'Contact valid',
        CREATED_BY_XERO: 'created by Xero',
        ERROR: 'Error:',
        EXPIRED: 'expired',
        INSUFFICIENT_USER_PERMISSIONS: 'Integration user no longer has admin permissions',
        VALID_USER_REASSIGNED: 'Integration user updated to user with admin permissions',
        INVOICE_LIMIT_REACHED: 'Maximum limit for invoices reached',
        INVOICE_LIMIT_RESET: 'Invoice limit refreshed for the month',
        LIST_CREATED: 'List created',
        LIST_NOT_FOUND: 'List not found',
        MADE_FROM_CLEARING_ACCOUNT: 'made from clearing account',
        MAPPED: 'mapped',
        MAPPINGS_UPDATED: 'mappings updated',
        MISSING_TRANSACTION_TYPE_MAPPING:
            'A new transaction type which is missing an account and tax rate mapping has been detected',
        MISSING_TRANSACTION_TYPES_MAPPED: 'Missing transaction types mapped',
        PROCESSED_FOR: 'processed for {integrationName}',
        REQUIRED_MERGE_FIELDS: 'Required merge fields',
        RESOLVED: 'Resolved:',
        SENT_TO: 'sent to {integrationName}',
        STARTED: 'started',
        SUBSCRIPTION_STARTED: 'Billing subscription started',
        TAX_RATE: 'Tax rate',
        TAX_RATES: 'Tax rates',
        TAX_RATE_LINKED_DELETED: 'One or more tax rates that are assigned to chart of accounts have been deleted',
        TAX_RATE_LINKED_INCORRECT: 'One or more tax rates that are assigned to chart of accounts have become invalid',
        TAX_RATES_VALID: 'Tax rates valid',
        TITLE: 'Activity report',
        TRANSACTION_IMPORT_RESUMED: 'Transaction import resumed:',
        IMPORTING_MISSING_TRANSACTIONS: 'Importing missing transactions',
        VERSION_UPDATED: 'Version updated',
        X_DAY_FREE_TRIAL: '30-day free trial',
        XERO: 'Xero',
    },
    LIST_FORM: {
        LIST_NAME: 'List',
        FROM_NAME: 'From name',
        FROM_EMAIL: 'From email address',
        EMAIL_PLACEHOLDER: 'example@emailaddress.com',
        PERMISSION_REMINDER: 'Remind people how they signed up to your list',
        PERMISSION_REMINDER_PLACEHOLDER: 'Write a short reminder about how the recipient joined your list.',
        INVALID_EMAIL: 'Invalid email',
    },
    SALES_LAYOUT: {
        ADMIN_TITLE: 'Contact your administrator',
        ADMIN_BLURB: 'You do not have sufficient permissions to access this page. Please contact your administrator.',
        UPGRADE_TITLE: 'Upgrade your Xero subscription',
        UPGRADE_BLURB: 'To install this application, please upgrade your Xero subscription to a Premium plan.',
    },
    ERROR: {
        FATAL: "You don't have access to this page",
        CONNECTION_ERROR:
            'Oops, we’ve had a problem connecting integrationName to Xero. Please click the ‘Disconnect app’ button below, and try connecting the app again.',
        UNKNOWN_ERROR: 'There is an error with your connection.',
        SUB: `If you think this is a mistake, <a href='//help.xero.com'>get in touch</a>.`,
        SOMETHING_WENT_WRONG: 'Something went wrong',
        GO_BACK_WAIT: "Please go back, wait a few minutes and try again. If that doesn't work, ",
        FIND_AN_ANSWER: 'find an answer in our help articles or contact Xero support',
        // Keeping this generic for all integrations
        FIND_AN_ANSWER_LINK: 'https://central.xero.com/s/contact-support',
        GO_BACK: 'Go back',
    },
    INFORMATION: {
        CONNECTING_TO: 'Connecting to integrationName.',
        DO_NOT_REFRESH: 'Do not refresh the page.',
        APP_UNAVAILABLE_IN_REGION: 'This app is unavailable in your location',
    },
    HEADINGS: {
        APPS: 'Apps',
        SETTINGS: 'settings',
    },
    URLS: {
        APPS: 'https://apps.xero.com/connected',
        PRICING: 'https://my.xero.com/MyXero/V2/PricingPlan.aspx',
    },
    TAGS: {
        LIABILITY: 'Liability',
        NEW: 'New',
    },
    MODALS: {
        DISCONNECT_APP: {
            MODAL_HEADER: 'Disconnect app',
            MODAL_MESSAGE_UNSUBSCRIBED:
                'Confirm the disconnection of the {integrationName} app from your organisation.',
            MODAL_MESSAGE: (
                integrationDisplayName: string,
                integrationName: string,
                hasPartnerStore: boolean = false
            ) => (
                <div data-automationid='subscription-disconnect-modal-body'>
                    <XUIModalBody>
                        {`Confirm the disconnection of the ${integrationDisplayName} app from your organisation.`}
                    </XUIModalBody>
                    <XUIModalBody>
                        {`The app can be reconnected in the Xero App Store${
                            hasPartnerStore ? ` or ${integrationName} App Store` : ''
                        }.`}
                    </XUIModalBody>
                    <XUIModalHeader>
                        <strong>{'Cancel or keep subscription'}</strong>
                    </XUIModalHeader>
                    <XUIModalBody>{`The ${integrationDisplayName} subscription remains active when the app is disconnected, unless cancelled.`}</XUIModalBody>
                </div>
            ),
            CLOSE_BUTTON: 'Close',
            CONFIRM_BUTTON: 'Disconnect',
            CONFIRM_BUTTON_ALTERNATIVE: 'Disconnect and cancel',
            RADIO_LIST_LABEL: '{integrationName} subscription',
            SUBSCRIPTION_DISCLAIMER_CANCEL:
                "Data will stop being imported immediately when you disconnect and cancel your subscription. You'll still be able to reconnect for no additional charge until the end of your billing cycle on {nextBillingDate}.",
            SUBSCRIPTION_DISCLAIMER_KEEP:
                'Your subscription for {integrationName} will remain active until you cancel it',
            VALIDATION_MESSAGE: 'Select whether to cancel or keep subscription',
        },
    },
    PENDING_CANCELLATION_BANNER: {
        HEADING: 'Upcoming cancellation',
        CONTENT:
            'Your subscription is set to end on {subscriptionEndDate}. Reactivate your subscription in the billing page to keep using {integrationName}',
    },
    DISCONNECTED_BANNER: {
        CONTENT: '{integrationName} has been successfully disconnected',
    },
    INSTALLATION_DISCONNECTED_SUBSCRIPTION_ACTIVE_BANNER: {
        HEADING: 'Your {integrationName} has been disconnected',
        CONTENT: (
            <span>
                Data has stopped importing. To continue using the integration, select <b>Connect app</b>.<br />
                Your subscription remains active and you'll continue to be charged.
            </span>
        ),
    },
    INSTALLATION_DISCONNECTED_SUBSCRIPTION_CANCELLED_BANNER: {
        HEADING: 'Your {integrationName} has been disconnected',
        CONTENT: (subscriptionEndDate: string) => (
            <span>
                Data has stopped importing. To continue using the integration, select <b>Connect app</b>.<br />
                <br />
                {`You'll still be able to reconnect for no additional charge until the end of your billing cycle on ${subscriptionEndDate}. `}
                If you wish to continue your subscription beyond this date, select <b>Manage subscription</b>.
            </span>
        ),
    },
};
